/**
 * @format
 */

import { getCookiesSession } from "../cookiesSession";
import { format, parseISO } from "date-fns";
import { showNotification } from '@mantine/notifications';

export const assetsPrefix = "/assets";

export const loadingStates = {
  NO_ACTIVE_REQUEST: "NO_ACTIVE_REQUEST",
  LOADING: "LOADING",
  FINISHED: "FINISHED",
  FAILED: "FAILED",
  SUCCEEDED: "SUCCEEDED",
};

export const getUserDataFromCookies = () => {
  let data = null;
  try {
    data = JSON.parse(getCookiesSession("trueCounselUserData"));
  } catch (e) {
    console.log(e);
  }
  return data;
};

export const cleanFileObj = (file) => {
  let fileName = file.fileData ? file.fileData.name : null;
  if (!fileName && file.name) {
    fileName = file.name;
  }
  if (!fileName && file.filename) {
    fileName = file.filename;
  }
  if (!fileName && file.fileName) {
    fileName = file.fileName;
  }
  if (!fileName && file.destination) {
    fileName = getFileName(file.destination);
  }
  if (!fileName || !fileName.length) {
    fileName = "Un-Named File";
  }
  return {
    fileName,
    destination: file.destination || null,
  };
};

export function nl2br(str, is_xhtml) {
  if (typeof str === "undefined" || str === null) {
    return "";
  }
  const breakTag =
    is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>";
  return `${str}`.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
}

export const getFileName = (url) => {
  const decoded = decodeURI(decodeURI(url));
  const splits = decoded.split("-tc-");
  if (splits.length === 2) {
    return splits[splits.length - 1]
      .split("/")
      .pop()
      .split("#")[0]
      .split("?")[0];
  }
  return null;
};

export const noticeRequestStatuses = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  ALL: "",
};

export const noticeStatuses = {
  ALL: "",
  ["INITIAL DRAFT"]: "INITIAL DRAFT",
  DRAFT: "DRAFT",
  SENT: "SENT",
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

// export const validateMobile = (phone) => {
//   return !isNaN(parseInt(phone, 10))
// }

export const validateMobile = (phone) => {
  if (isNaN(phone)) {
    return false;
  }
  return !isNaN(parseInt(phone, 10));
};

export const validateAddress = (addr) => {
  const erroredKeys = [];
  if (!addr.type.length) {
    erroredKeys.push("type");
  }
  if (addr.name.length < 3) {
    erroredKeys.push("name");
  }
  if (addr.email.length < 3) {
    erroredKeys.push("email");
  }
  if (!validateEmail(addr.email)) {
    erroredKeys.push("email");
  }
  if (addr.type === "Individual") {
    if (addr.phone.length < 10) {
      erroredKeys.push("phone");
    }
    if (isNaN(parseInt(addr.phone, 10))) {
      erroredKeys.push("phone");
    }
    if (addr.sonOf.length < 3) {
      erroredKeys.push("sonOf");
    }
    if (addr.residenceOf.length < 5) {
      erroredKeys.push("residenceOf");
    }
  }
  if (addr.type === "Entity") {
    if (addr.registeredOfficeAddress.length < 5) {
      erroredKeys.push("registeredOfficeAddress");
    }
    if (addr.corporateOfficeAddress.length < 5) {
      erroredKeys.push("corporateOfficeAddress");
    }
    if (addr.companyType.length < 3) {
      erroredKeys.push("companyType");
    }
  }
  return { result: erroredKeys.length === 0, erroredKeys };
};

const cleanAddrObject = (addr, type = "truncate") => {
  const newAddr = { ...addr };
  if (newAddr.type === "Individual") {
    if (type === "remove") {
      delete newAddr.registeredOfficeAddress;
      delete newAddr.corporateOfficeAddress;
      delete newAddr.companyType;
    }
    if (type === "truncate") {
      newAddr.corporateOfficeAddress = "";
      newAddr.companyType = "";
      newAddr.registeredOfficeAddress = "";
    }
  }
  if (newAddr.type === "Entity") {
    if (type === "remove") {
      delete newAddr.phone;
      delete newAddr.sonOf;
      delete newAddr.residenceOf;
    }
    if (type === "truncate") {
      newAddr.phone = "";
      newAddr.sonOf = "";
      newAddr.residenceOf = "";
    }
  }
  return newAddr;
};

export const formatTime = (time) => {
  let tempDate = time;
  if (!tempDate) {
    return "-";
  }
  if (!(typeof tempDate.getMonth === "function")) {
    try {
      tempDate = parseISO(tempDate);
    } catch (e) {
      console.log(e);
      tempDate = null;
    }
  }
  if (!tempDate) {
    return "-";
  }
  return format(tempDate, "hh:mm aa");
};

export const formatDate = (dateString) => {
  dateString = dateString;
  if(!dateString) {
      return "-";
  }
  var datePart = dateString.split('T')[0].split(' ')[0];
  var dateParts = datePart.split('-');
  var year = dateParts[0];
  var month = parseInt(dateParts[1], 10) - 1;
  var day = dateParts[2];
  var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return day + ' ' + monthNames[month] + ' ' + year;
};

export const formatNumberWithCommas = (number) => {
  console.log(number);
  if (!number) return "";
  number = number.toString().replace(/,/g, "");
  return number.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
};

export const taskStatuses = {
  CREATED: "CREATED",
  COMPLETED: "COMPLETED",
  ARCHIVED: "ARCHIVED",
};

export const isDateObj = (value) => {
  if (!value) {
    return false;
  }
  return typeof value.getMonth === "function";
};

export const existsAndLength = (value) => {
  return value?.length > 3;
};

export const transformFirebaseNotifs = (notifs) => {
  const keys = Object.keys(notifs);
  const arr = [];
  keys.forEach((notifKey) => {
    arr.push({ ...notifs[notifKey], key: notifKey });
  });
  return arr;
};

export const getUploadedFileFromObj = (file) => {
  return {
    ...file,
    uploadedComplete: true,
    uploadStarted: true,
  };
};

export const getValueForInput = (incoming) => {
  let value;
  if (incoming.target) {
    if (incoming.target.value !== undefined) {
      value = incoming.target.value;
    }
  } else {
    value = incoming;
  }
  return value;
};

export const addressDefaultData = {
  type: "Individual",
  name: "",
  email: "",
  phone: "",
  sonOf: "",
  residenceOf: "",
  companyType: "Company",
  registeredOfficeAddress: "",
  corporateOfficeAddress: "",
};

export const isLoading = (value) => value === loadingStates.LOADING;

export const arrayToTextList = (arr) => arr.join(", ");

export const handleFromEmail = (obj) => {
  if (Array.isArray(obj)) {
    return obj;
  }
  return [obj?.email || ""];
};

export const randomColorPicker = (length) => {
  // colors taken from https://colorhunt.co/palettes/pastel
  const colors = [
    "#829460",
    "#AD7BE9",
    "#EDC6B1",
    "#7C96AB",
    "#05BFDB",
    "#EB455F",
    "#645CBB",
    "#867070",
    "#804674",
    "#FF8787",
    "#EA8FEA",
    "#805674",
    "#8FBDD3",
    "#B97A95",
    "#829463",
    "#EDC6B5",
    "#7C96A8",
    "#EB4542","#EB4542",
  ];
  const randomColors = [];

  //while (true) {
  //  const randomColor = colors[Math.floor(Math.random() * colors.length)];
  //  if (!randomColors.includes(randomColor)) {
  //    randomColors.push(randomColor);
  //    if (randomColors.length === length) break;
  //  }
  //}
  for (var i = 0; i < length; i++) {
    randomColors.push(getRandomColor());
  }
  return randomColors;
};
export const getRandomColor = () => {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
export const randomColorPickerForLocation = (length) => {
  // colors taken from https://colorhunt.co/palettes/pastel
  const colors = [
    "#829460",
    "#AD7BE9",
    "#EDC6B1",
    "#7C96AB",
    "#05BFDB",
    "#EB455F",
    "#645CBB",
    "#867070",
    "#804674",
    "#FF8787",
    "#EA8FEA",
    "#804654",
    "#8FBDD3",
    "#B97A95",
    "#829463",
    "#EDC6B5",
    "#7C96A8",
    "#EB4542",
    "#829450",
    "#AD7C49",
    "#EB444F",
    "#ECD6B1",
    "#7B56AB",
    "#77BFDB",
    "#EB4666",
    "#546CBB",
    "#867460",
    "#893674",
    "#DD8787",
    "#FEAFEA",
    "#804784",
    "#8FBEE3",
    "#B97A99",
    "#833463",
    "#EAA6B5",
    "#7E76A8",
    "#EB4552",
    "#899450",
    "#AD7C09",
  ];
  const randomColors = [];

  //while (true) {
  //  const randomColor = colors[Math.floor(Math.random() * colors.length)];
  //  randomColors.push(randomColor);
  //  if (randomColors.length === length) break;
  //}
  for (var i = 0; i < length; i++) {
    randomColors.push(getRandomColor());
  }
  return randomColors;
};

const chartData = {
  labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
  datasets: [
    {
      label: "# of Votes",
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        "#3a36db",
        "#1f6fbd",
        "#03a89e",
        "#8189a9",
        "#c079af",
        "#ff69b4",
      ],
      borderColor: [
        "#3a36db",
        "#1f6fbd",
        "#03a89e",
        "#8189a9",
        "#c079af",
        "#ff69b4",
      ],
      borderWidth: 1,
    },
  ],
};

export const customChartData = (prop) => (wiseData) => {
  const data = structuredClone(chartData);
  data.labels = wiseData.map((item) => item[prop].toUpperCase());
  data.datasets[0].data = wiseData.map((item) => item["_count"].id);
  data.datasets[0].backgroundColor = [...randomColorPicker(wiseData.length)];
  data.datasets[0].borderColor = [...data.datasets[0].backgroundColor];
  return { ...data };
};

export const customChartDataForLocation = (prop) => (wiseData) => {
  const data = structuredClone(chartData);
  data.labels = wiseData.map((item) => item[prop].toUpperCase());
  data.datasets[0].data = wiseData.map((item) => item["_count"].id);
  data.datasets[0].backgroundColor = [...randomColorPickerForLocation(wiseData.length)];
  data.datasets[0].borderColor = [...data.datasets[0].backgroundColor];
  return { ...data };
};

export const totalCountChart = (data) =>
  data.reduce((sum, { _count }) => sum + _count.id, 0);

export const camelCaseToTitle = (text) => {
  const result = text.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const csvDownload = ({ headers, data, name }) => {
  let csvContent = `data:text/csv;charset=utf-8,`;
  csvContent += headers.join(",") + "\n";

  data.forEach((item) => {
    headers.forEach((header) => {
      csvContent += `${item[header]},`;
    });
    csvContent += "\n";
  });

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `${name}.csv`);
  document.body.appendChild(link);
  link.click();
};

export const copyToClipboard = async (textToCopy) => {
  try {
    await navigator.clipboard.writeText(textToCopy);
    console.log('Text copied to clipboard');
    showNotification({
      color: "green",
      message: "Text copied to clipboard",
    });
  } catch (error) {
    console.error('Failed to copy text:', error);
    showNotification({
      color: "red",
      message: "Unable to copy the text into clipboard",
    });
  }
};

export const extractFirstTwoLinesOfHtml = (htmlString) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;
  const textContent = tempDiv.textContent || tempDiv.innerText || '';
  const lines = textContent.split('\n').map(line => line.trim()).filter(line => line.length > 0);
  return lines.slice(0, 2).join(' ');
}